export default {
  name: "ProductManage"
};